export interface ExtendedProperty {
  id: string;
  address: string;
  community: string;
  city: string;
  image?: string;

  // Financials
  exchangePrice: number;
  askingPrice: number;
  pricePSF: number;
  rentalYield: number;

  // Specs
  sqft: number;
  bedrooms: number;
  bathrooms: number;
  propertyType: string;

  // Meta
  nearestSchool?: string;
  schoolDistanceKm?: number;
  nearestHospital?: string;
  hospitalDistanceKm?: number;

  // additional optional fields
  postcode: string;
  status?: string;
  daysOnMarket?: number;
  yearQuarter?: string;
}

const IMAGES = [
  "https://images.ctfassets.net/zoq5l15g49wj/2NfFkdfIKyjS3FZKGZzeTX/059b95abb34cbab3ee6271b72d763661/executive-bay-hero-image-mobile.jpg",
  "https://www.mepmiddleeast.com/cloud/2023/05/15/dAMAC-CANAL-CROWN.jpg",
  "https://cdn.prod.website-files.com/63bd7443c5c4c66606ad6362/64704fd397e25e08af6b1b2b_LZ002-1-S010-Birdseyes_R02.jpg",
  "https://cf.bstatic.com/xdata/images/hotel/max1024x768/604121212.jpg?k=8826e128f09460f30ebe5d1bd88c89d730ad2df68d6e62f3465079fa03a19e10&o=",
  "https://www.binayah.com/wp-content/uploads/2023/11/The-Pad-Banner.jpg",
  "https://images.ctfassets.net/zoq5l15g49wj/3yCJXThZG0mGfh1HVoHlte/a6db1f47f6b0a8a04e96e08f099842dc/Reva_Residences-Gallery-00.jpg",
  "https://metropolitan.realestate/wp-content/uploads/2023/02/canal-heights-7.jpg",
  "https://images.ctfassets.net/zoq5l15g49wj/hiQt6myyios4vy15M1EEh/23adaf9b5f737ca8047a70b8db6434ac/AYKON_CITY_-_TOWER_B-Gallery-00.jpg",
];

export const INITIAL_PROPERTIES: ExtendedProperty[] = [
  {
    id: "PROP-DB-001",
    address: "Executive Bay Residence",
    community: "Business Bay",
    city: "Dubai",
    postcode: "Business Bay",
    propertyType: "Apartment",
    bedrooms: 2,
    bathrooms: 2,
    sqft: 1350,
    exchangePrice: 2150000,
    askingPrice: 2150000,
    pricePSF: Math.round(2150000 / 1350),
    rentalYield: 4.2,
    nearestSchool: "Dubai International School",
    schoolDistanceKm: 2.5,
    nearestHospital: "American Hospital Dubai",
    hospitalDistanceKm: 1.8,
    image: IMAGES[0],
  },
  {
    id: "PROP-DB-002",
    address: "Canal Crown Tower",
    community: "Business Bay",
    city: "Dubai",
    postcode: "Business Bay",
    propertyType: "Apartment",
    bedrooms: 3,
    bathrooms: 3,
    sqft: 1980,
    exchangePrice: 3450000,
    askingPrice: 3450000,
    pricePSF: Math.round(3450000 / 1980),
    rentalYield: 4.5,
    nearestSchool: "Emirates National School",
    schoolDistanceKm: 2,
    nearestHospital: "Mediclinic City Hospital",
    hospitalDistanceKm: 1.6,
    image: IMAGES[1],
  },
  {
    id: "PROP-DB-003",
    address: "Peninsula Five",
    community: "Business Bay",
    city: "Dubai",
    postcode: "Business Bay",
    propertyType: "Apartment",
    bedrooms: 1,
    bathrooms: 1,
    sqft: 820,
    exchangePrice: 1480000,
    askingPrice: 1480000,
    pricePSF: Math.round(1480000 / 820),
    rentalYield: 5.1,
    nearestSchool: "GEMS World Academy",
    schoolDistanceKm: 3.2,
    nearestHospital: "Emirates Hospital Jumeirah",
    hospitalDistanceKm: 2.3,
    image: IMAGES[2],
  },
  {
    id: "PROP-DB-004",
    address: "DAMAC Maison Privé",
    community: "Business Bay",
    city: "Dubai",
    postcode: "Business Bay",
    propertyType: "Serviced Apartment",
    bedrooms: 2,
    bathrooms: 2,
    sqft: 1420,
    exchangePrice: 2620000,
    askingPrice: 2620000,
    pricePSF: Math.round(2620000 / 1420),
    rentalYield: 4.7,
    nearestSchool: "Hartland International School",
    schoolDistanceKm: 3.8,
    nearestHospital: "American Hospital Dubai",
    hospitalDistanceKm: 2.0,
    image: IMAGES[3],
  },
  {
    id: "PROP-DB-005",
    address: "The Pad by Omniyat",
    community: "Business Bay",
    city: "Dubai",
    postcode: "Business Bay",
    propertyType: "Apartment",
    bedrooms: 3,
    bathrooms: 3,
    sqft: 2100,
    exchangePrice: 4150000,
    askingPrice: 4150000,
    pricePSF: Math.round(4150000 / 2100),
    rentalYield: 4.0,
    nearestSchool: "Jumeirah English Speaking School",
    schoolDistanceKm: 4.1,
    nearestHospital: "Mediclinic City Hospital",
    hospitalDistanceKm: 1.9,
    image: IMAGES[4],
  },
  {
    id: "PROP-DB-006",
    address: "Reva Residences",
    community: "Business Bay",
    city: "Dubai",
    postcode: "Business Bay",
    propertyType: "Apartment",
    bedrooms: 1,
    bathrooms: 1,
    sqft: 790,
    exchangePrice: 1320000,
    askingPrice: 1320000,
    pricePSF: Math.round(1320000 / 790),
    rentalYield: 5.3,
    nearestSchool: "GEMS Wellington Primary School",
    schoolDistanceKm: 3.5,
    nearestHospital: "Emirates Hospital Jumeirah",
    hospitalDistanceKm: 2.6,
    image: IMAGES[5],
  },
  {
    id: "PROP-DB-007",
    address: "Canal Heights",
    community: "Business Bay",
    city: "Dubai",
    postcode: "Business Bay",
    propertyType: "Apartment",
    bedrooms: 2,
    bathrooms: 3,
    sqft: 1560,
    exchangePrice: 2980000,
    askingPrice: 2980000,
    pricePSF: Math.round(2980000 / 1560),
    rentalYield: 4.4,
    nearestSchool: "Dubai International School",
    schoolDistanceKm: 2.7,
    nearestHospital: "American Hospital Dubai",
    hospitalDistanceKm: 1.7,
    image: IMAGES[6],
  },
  {
    id: "PROP-DB-008",
    address: "Aykon City Tower C",
    community: "Business Bay",
    city: "Dubai",
    postcode: "Business Bay",
    propertyType: "Apartment",
    bedrooms: 3,
    bathrooms: 4,
    sqft: 2350,
    exchangePrice: 4980000,
    askingPrice: 4980000,
    pricePSF: Math.round(4980000 / 2350),
    rentalYield: 3.9,
    nearestSchool: "Emirates National School",
    schoolDistanceKm: 2.1,
    nearestHospital: "Mediclinic City Hospital",
    hospitalDistanceKm: 1.8,
    image: IMAGES[7],
  },
];

export default INITIAL_PROPERTIES;
